


































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";
import {
    IPromotionModel,
    IPromotionItemModel,
    ICheckoutModel,
    IOrderModel
} from "../models";
import { AppGetterTypes } from "../store";
import { Step1Route, Step2Route, ThankYouRoute } from "../router";
import { getOrderTotal, getPromotionProducts } from "../helpers";

@Component({ name: "ShoppingCart" })
export default class ShoppingCart extends Vue {
    @Getter(AppGetterTypes.promotion)
    promotion!: IPromotionModel;

    @Getter(AppGetterTypes.checkout)
    checkout!: ICheckoutModel;

    @Getter(AppGetterTypes.order)
    order!: IOrderModel;

    //TODO: the shopping cart should be independent of the route ...

    get isStepOne(): boolean {
        return this.$route.name === Step1Route.name;
    }

    get isStepTwo(): boolean {
        return this.$route.name === Step2Route.name;
    }

    get isThankYou(): boolean {
        // Compare names (not paths) to match on the current route.
        // ...since paths won't match due to route parameters.
        return this.$route.name === ThankYouRoute.name;
    }

    get softDeclined(): boolean {
        return !!this.isThankYou && this.order && !!this.order.isSoftDeclined;
    }

    get promotionProducts(): IPromotionItemModel[] {
        if (this.order && this.order.items) {
            return getPromotionProducts(this.order.items);
        }

        if (this.promotion && this.checkout) {
            return getPromotionProducts(
                this.promotion.products || [],
                this.promotion.upsellProducts || [],
                this.checkout.upsellIds || []
            );
        }

        return [];
    }

    get orderTotal(): number {
        if (this.isThankYou && this.order && this.order.orderTotal) {
            return this.order.orderTotal;
        }

        return getOrderTotal(this.promotionProducts);
    }
}
